<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Stock valorizado</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Stock valorizado</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="min-width: 175px; max-width: 12%;">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline" style="margin-right: 20px;">
            <input type="radio" class="form-check-input" id="rbVistaResumen" [value]="RB_TIPO_VISTA_RESUMEN"
              formControlName="tipoVista" mdbInput />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" [value]="RB_TIPO_VISTA_DETALLE"
              formControlName="tipoVista" mdbInput />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detalle</label>
          </div>
        </div>

        <div class="col" style="max-width: 150px; min-width: 150px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fecha" [placeholder]="'Fecha'" required formControlName="fecha">
            </mdb-date-picker>
            <label>Fecha</label>
            <div
              *ngIf="formHeader.get('fecha').invalid && (formHeader.get('fecha').dirty || formHeader.get('fecha').touched)">
              <mdb-error *ngIf="formHeader.get('fecha').hasError('required')">Ingrese fecha </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="min-width: 200px; max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodega"> </mdb-select>
            <label>Bodega</label>
          </div>
        </div>
        <div class="col" style="min-width: 200px; max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Rubro" formControlName="rubro"> </mdb-select>
            <label>Rubro</label>
          </div>
        </div>
        <div class="col" style="min-width: 200px; max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Familia" formControlName="familia"> </mdb-select>
            <label>Familia</label>
          </div>
        </div>
        <!-- <div class="col" style="max-width: 300px;">
                    <div class="md-form mb-0">
                        <mdb-select [options]="optionsEstado" [multiple]="true" [filterEnabled]="true"
                            [highlightFirst]="false" placeholder="Seleccionar Estado" formControlName="estado">
                        </mdb-select>
                        <label>Estado</label>
                    </div>
                </div> -->
        <div class="col" style="max-width: 150px">
          <div class="md-form mt-4" style="margin-bottom: 0">
            <mdb-checkbox formControlName="estado"><span style="font-size: 1rem">Incluir Inactivo</span> </mdb-checkbox>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form mt-4" style="margin-bottom: 0">
            <mdb-checkbox formControlName="mayor"><span style="font-size: 1rem">Stock Mayor a 0</span> </mdb-checkbox>
          </div>
        </div>

      </div>
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsPrecioRef" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Precio de Referencia" formControlName="precioRef"></mdb-select>
            <label>Precio ref.</label>
          </div>
        </div>

      </div>

      <div class="row filtros-body"></div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="resumen_loading || detalle_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="resumen_loading || detalle_loading" spinnerColor="blue"></mdb-spinner>
    </div>

    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <app-no-data-alert *ngIf="resumen_listaMovimientos?.length === 0"></app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">UXE</th>
            <th scope="col">Rubro</th>
            <th scope="col">Familia</th>
            <th scope="col" style="text-align: right">Caja</th>
            <th scope="col" style="text-align: right">Fracción</th>
            <th scope="col" style="text-align: right">Prec. Ref.</th>
            <!-- <th scope="col" style="text-align: right">Total</th> -->
            <th scope="col">Estado</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let movimiento of resumen_listaMovimientos">
            <td>{{ movimiento.sku }}</td>
            <td>{{ movimiento.producto_descripcion }}</td>
            <td>{{ obtenerFormatoPrincipal(movimiento.listaStockxUnidades).cantidad_formato }}</td>
            <td>{{ movimiento.rubro_nombre }}</td>
            <td>{{ movimiento.familia_nombre }}</td>
            <td class="text-right">{{ calcularStockFormatoPrincipalConSaldo(movimiento.listaStockxUnidades,
              movimiento.saldo) }}</td>
            <td class="text-right">{{ calcularStockFormatoSecundarioConSaldo(movimiento.listaStockxUnidades,
              movimiento.saldo) }}</td>
            <!-- <td class="text-right">{{movimiento.precio_unidad_nuevo | numerico}}</td> -->
            <td class="text-right">{{ movimiento.precio_ref | numerico }}</td>
            <!-- <td class="text-right">{{ calcularPrecioRefTodosLosFormatos(movimiento.listaStockxUnidades,
              movimiento.precio_ref) | numerico }}</td> -->
            <td>
              <mdb-badge pill="true" success="true" *ngIf="movimiento.producto_activo"> Activo</mdb-badge>
              <mdb-badge pill="true" default="true" *ngIf="!movimiento.producto_activo"> Inactivo</mdb-badge>
            </td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="5"><strong></strong></td>
            <td class="text-right">
              <strong>
                <span style="color: red;">Totales </span>
                <span>{{(detalle_totales != null ? detalle_totales.total_caja_detalle : resumen_totales?.total_caja) |
                  numerico}}</span>
              </strong>
            </td>
            <td class="text-right">
              <strong>
                <span>{{(detalle_totales != null ? detalle_totales.total_fraccion_detalle :
                  resumen_totales?.total_fraccion) | numerico}}</span>
              </strong>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
            <td class="text-right" colspan="7"><strong></strong></td>
            <td class="text-right" colspan="2">
              <strong>
                <span style="color: red;">Total General </span>
                <span *ngIf="detalle_loading" class="grey-text">…</span>
                <span *ngIf="!detalle_loading && detalle_totales != null">{{ detalle_totales.total_detalle | numerico }}</span>
                <span *ngIf="!detalle_loading && detalle_totales == null && resumen_totales != null">{{ resumen_totales.total | numerico }}</span>
                <span *ngIf="!detalle_loading && detalle_totales == null && resumen_totales == null" class="grey-text">—</span>
              </strong>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="resumen_paginationContext" (onPageChange)="onPageChangeResumen($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">UXE</th>
            <th scope="col">Bodega</th>
            <th scope="col">Rubro</th>
            <th scope="col">Familia</th>
            <th scope="col" style="text-align: right">Caja</th>
            <th scope="col" style="text-align: right">Fracción</th>
            <!-- <th scope="col" style="text-align: right">Stock</th> -->
            <!-- <th scope="col" style="text-align: right;">Prec.Unit.</th> -->
            <th scope="col" style="text-align: right">Prec. Ref.</th>
            <th scope="col" style="text-align: right">Total</th>
            <th scope="col">Estado</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let movimiento of detalle_listaMovimientos">
            <td>{{ movimiento.sku }}</td>
            <td>{{ movimiento.producto_descripcion }}</td>
            <td>{{ obtenerFormatoPrincipal(movimiento.listaStockxUnidadesxBodega).cantidad_formato }}</td>
            <td>{{ movimiento.bodega_nombre }}</td>
            <td>{{ movimiento.rubro_nombre }}</td>
            <td>{{ movimiento.familia_nombre }}</td>
            <td class="text-right">{{ calcularStockFormatoPrincipalConSaldo(movimiento.listaStockxUnidadesxBodega,
              movimiento.saldo) }}</td>
            <td class="text-right">{{ calcularStockFormatoSecundarioConSaldo(movimiento.listaStockxUnidadesxBodega,
              movimiento.saldo) }}</td>
            <!-- <td class="text-right">{{ movimiento.saldo | numerico }}</td> -->
            <!-- <td class="text-right">{{movimiento.precio_unidad_nuevo | numerico}}</td> -->
            <td class="text-right">{{ movimiento.precio_ref | numerico }}</td>
            <td class="text-right">{{ calcularPrecioRefTodosLosFormatosBodega(movimiento.listaStockxUnidadesxBodega,
              movimiento.precio_ref, movimiento.costo_formato_principal) | numerico }}</td>
            <td>
              <mdb-badge pill="true" success="true" *ngIf="movimiento.producto_activo"> Activo</mdb-badge>
              <mdb-badge pill="true" default="true" *ngIf="!movimiento.producto_activo"> Inactivo</mdb-badge>
            </td>
          </tr>
        </tbody>
        <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="6"><strong></strong></td>
            <td class="text-right">
              <strong>
                <span style="color: red;">Totales </span>
                <span>{{detalle_totales.total_caja_detalle | numerico}}</span>
              </strong>
            </td>
            <td class="text-right">
              <strong>
                <span>{{detalle_totales.total_fraccion_detalle | numerico}}</span>
              </strong>
            </td>
            <td></td>
            <td class="text-right">
              <strong>
                <span>{{detalle_totales.total_detalle | numerico }}</span>
              </strong>
            </td>
            <td></td>
          </tr>
        </tbody>
        <app-pagination [context]="detalle_paginationContext" (onPageChange)="onPageChangeDetalle($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <!-- <div class="table-responsive" *ngIf="listaMovimientos?.length > 0">
      <table class="table table-striped table-hover table-sm align-middle">
        <tbody>
          <tr>
            <td class="col-10" style="font-weight: bold; font-size: 15px;text-align: right;">
              <span style="color: red;">Total </span>
              <span>{{ totales.total | numerico }}</span>
            </td>
        </tbody>
      </table>
    </div> -->

  </div>
</div>


<div class="card mb-2 wow" *ngIf="detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="exportarExcel()">Excel</button>
    <!-- <button mdbBtn type="button" color="success" mdbWavesEffect class="btn">PDF</button> -->
  </div>
</div>